import { createStore } from '/src/core/store';
import { useSocket } from '/src/composables/useSocket.js';

import {
	usePersistStorePlugin,
	useSocketsStorePlugin,
} from '/src/core/store/plugins';

import {
	createLocalStorageAdapter,
	createSessionStorageAdapter,
	createCookiesAdapter,
	createNativePreferencesAdapter,
	createFilesystemAdapter,
} from './adapters/index.js';

// create store
const store = createStore();

// Configure persist plugin with storage adapters
const persistPlugin = usePersistStorePlugin({
	// Namespace (optional) - Prevents key collisions across apps
	// Uncomment to enable: all keys will be prefixed with namespace
	// Format: {namespace}:{storeName}:{key}
	// Example: sesame-wall-v3:auth:token
	// namespace: 'sesame-wall-v3',
	storages: {
		// Web storage (1-2 MB on mobile, 5 MB on desktop)
		local: createLocalStorageAdapter(),
		session: createSessionStorageAdapter(),
		cookies: createCookiesAdapter(),

		// Native storage (50-100 MB)
		native: createNativePreferencesAdapter(),

		// Filesystem storage (unlimited on native, 50MB-1GB on web)
		filesystem: createFilesystemAdapter(),
	},
});

// Configure sockets plugin with socket instance
const { socket } = useSocket();
const socketsPlugin = useSocketsStorePlugin({
	socket,
});

// install plugins
store.use(persistPlugin);
store.use(socketsPlugin);

export default store;
